import api from './api';

export const listBugs = (params) =>
  api.get('/admin/bug-log', { params }).then(r => r.data.bugs);

export const createBug = (fields) =>
  api.post('/admin/bug-log', fields).then(r => r.data);

export const updateBug = (id, fields) =>
  api.put(`/admin/bug-log/${id}`, fields).then(r => r.data);

export const listNotes = (id) =>
  api.get(`/admin/bug-log/${id}/notes`).then(r => r.data);

export const addNote = (id, note) =>
  api.post(`/admin/bug-log/${id}/notes`, { note }).then(r => r.data);

/** Auth here is a Bearer header, not a cookie, so a plain <a href> can't
 * carry it — fetch as a blob and trigger the download client-side instead. */
export const downloadCsv = async (params) => {
  const res = await api.get('/admin/bug-log/export.csv', { params, responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = `365reset-bug-log-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
